import React from 'react'
import styled from 'styled-components'
import {
  CircleWarningIcon as CircleWarningIconBase,
  CircleSuccessIcon as CircleSuccessIconBase
} from '@chilecompra/react-kit/components'

export const DialogWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`

export const Row = styled('div')`
  margin: 16px 0 0;
  text-align: center;
  width: 100%;
`

export const CircleSuccessIcon = styled(({ fontSize, ...props }) => <CircleSuccessIconBase {...props} />)`
  &.MuiSvgIcon-root {
    font-size: ${props => props.fontSize};
  }
`

export const CircleWarningIcon = styled(({ fontSize, ...props }) => <CircleWarningIconBase {...props} />)`
  &.MuiSvgIcon-root {
    font-size: ${props => props.fontSize};
  }
`
